/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

var Util = require('../../lib/Util.js');

Magix.applyStyle("xf2c",".related-search-outer .related-search{height:41px;line-height:41px;background:#f5f5f5;border:1px solid #e9e9e9;overflow:hidden;padding:0 0 0 19px}.related-search-outer .related-search dt{font-weight:400;float:left;color:#747474;margin:0 -2px 0 0;font-size:12px}.related-search-outer .related-search dd{float:left;font-size:12px}.related-search-outer .related-search dd a{border-right:1px solid #666;padding:0 13px 0 12px;color:#333;text-decoration:none}.related-search-outer .related-search dd a:hover{color:#ef470f}");

module.exports = Magix.View.extend({
  tmpl: {"html":"1\u001d","subs":[{"keys":["entity"],"path":"#\u001f","tmpl":"<%if($$.entity&&$$.entity.length>0){%><div id=\"J_stextlink\" class=\"related-search-outer\"><dl mx-guid=\"g1\u001f\" class=\"related-search J_proxy_textlink\" data-linkpid=\"<%= $$.linkpid%>\">2\u001d</dl></div><%}%>","s":"1\u001d"},{"keys":["linkpid","entity"],"path":"dl[mx-guid=\"g1\u001f\"]","tmpl":"<dt>您是不是想找:</dt><%$$.entity.forEach(function(a){%><dd><a href=\"<%= a.clickUrl%>&page=0\"><%= a.title%></a></dd><%})%>","s":"2\u001d","attr":"data-linkpid=\"<%= $$.linkpid%>\"","attrs":[{"n":"data-linkpid"}],"mask":"21"}]},
  ctor: function ctor(opt) {
    this.opt = $.extend(true, opt, {
      S: KISSY
    });
  },
  render: function render() {
    var S = this.opt.S,
        self = this;

    Util.sync(self.opt.p4ptextlink, {}, function (json) {

      self.updater.set({
        entity: json.data.data1,
        linkpid: self.opt.linkpid
      }).digest();

      var con = S.one('.related-search');
      var anchor = S.all('a', con);
      S.each(anchor, function (item) {
        item.href = item.href.replace(/&amp;/g, '&');
      });
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/textlinks/index.js
// module id = 8
// module chunks = 1 2